// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDVwgxXqQHZcAszSLuJF7WNe8MhnPFUE9g",
    authDomain: "thought-bubbles-7a081.firebaseapp.com",
    projectId: "thought-bubbles-7a081",
    storageBucket: "thought-bubbles-7a081.firebasestorage.app",
    messagingSenderId: "280619146053",
    appId: "1:280619146053:web:ec1432476666176d7efc2c",
    measurementId: "G-G4WP209BQQ"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
//const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export const requestPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, {
                vapidKey: "BMukRoRYUPO9lW2BxiFwQCXSRQLn9OPJNCsh7-rFVEHiMw16LDT8j89S2LoZBkkaD60AH0qxPShdtgo40IUvsAY",
            });
            console.log("FCM Token:", token);
            return token;
        } else {
            console.log("Notification permission denied");
        }
    } catch (err) {
        console.error("Error getting FCM token", err);
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });

export { db, messaging, auth, googleProvider };
